<template>
  <NxInput
    name="nome"
    type="text"
    label="Número do Celular:"
    placeholder="Digite o Número do Celular"
    @update:value="handleValueUpdate"
    v-mask="['(##) ####-####', '(##) # ####-####']"
    :value="displayValue"
  ></NxInput>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'
import { VueMaskDirective } from 'vue-the-mask'

export default {
  name: 'NxInputClientWApp',
  mixins: [useReactiveModelMixin('value')],
  directives: {
    mask: VueMaskDirective
  },
  data () {
    return {
      localValue: ''
    }
  },
  computed: {
    displayValue () {
      return this.localValue
    }
  },
  methods: {
    handleValueUpdate (val) {
      if (val) {
        this.localValue = val
        this.$emit('update:value', `55${encodeURIComponent(val)}`)
      } else {
        this.localValue = null
        this.$emit('update:value', null)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputClientWApp.vue